/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

const setAutopilotEnabledDataSchema = z.object({
  enabled: z.boolean(),
});

export interface ISetAutopilotEnabledV1Data {
  enabled: boolean;
}

export const setAutopilotEnabledV1ResponseSchema = createApiResponseSchema(
  setAutopilotEnabledDataSchema,
) as z.ZodSchema<IAPI<ISetAutopilotEnabledV1Data>>;

export type ISetAutopilotEnabledV1Response = IAPI<ISetAutopilotEnabledV1Data>;
